// extracted by mini-css-extract-plugin
export default {"card-header":"CardHeader_card-header__uJakT"};